import { Toaster } from "sonner";
import React from "react";

export function ToastProvider(): JSX.Element {
  return (
    <Toaster
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: "bg-surface text-foreground shadow-md border border-border",
          success: "bg-surface text-foreground",
          error: "bg-surface text-foreground",
          warning: "bg-surface text-foreground",
          info: "bg-surface text-foreground",
          actionButton: "bg-brand-primary hover:bg-brand-primary/90 text-white",
          cancelButton: "text-foreground",
          description: "text-muted-foreground",
        },
      }}
    />
  );
}
